import { $, owlCarousel } from "./imports";

const alliancesAboutCarousel = () => {
    if($('.alliances-about .alliances-about__list .alliance-card').length > 1){
        let $alliancesCarousel = $('.alliances-about .alliances-about__list').addClass('owl-carousel').owlCarousel({
            nav: false,
            dots: true,
            margin: 20,
            navText: [
                '<svg xmlns="http://www.w3.org/2000/svg" width="8.551" height="13.847" viewBox="0 0 8.551 13.847"><path d="M15.514,6l1.627,1.627-5.285,5.3,5.285,5.3-1.627,1.627L8.59,12.923Z" transform="translate(-8.59 -6)" fill="#3c271a"/></svg>',
                '<svg xmlns="http://www.w3.org/2000/svg" width="8.551" height="13.847" viewBox="0 0 8.551 13.847"><path d="M10.217,6,8.59,7.627l5.285,5.3L8.59,18.22l1.627,1.627,6.923-6.923Z" transform="translate(-8.59 -6)" fill="#3c271a"/></svg>'
            ],
            loop: true,
            items: 1,
            autoplay: true,
            autoplayTimeout: 8000,
            autoplayHoverPause: true,
            // autoWidth: true,
            // center: true,
            responsive: {
                0:{
                    nav: false,
                    dots: true,
                    items: 1,
                    margin: 20,
                },
                768: {
                    nav: true,
                    dots: true,
                    items: 1,
                    margin: 20,
                },
                992: {
                    nav: true,
                    dots: true,
                    items: 1.5,
                    margin: 20,
                },
                1200: {
                    nav: true,
                    dots: true,
                    items: 2,
                    margin: 40,
                },
            }
        });
    }
}

export default alliancesAboutCarousel;